import { FleetMapAreaDataTestIds } from '@backoffice-frontend/common'
import { trackClickEvent } from '@backoffice-frontend/tracking'
import type { VehicleListOverlayVehicleFragment } from './VehicleListOverlay.hook'
import { VehicleListOverlayRow } from './VehicleListOverlayRow'

const { List } = FleetMapAreaDataTestIds.Vehicle

type VehicleListOverlayProps = {
  selectedVehicleId?: string
  vehicles: VehicleListOverlayVehicleFragment[]
  handleVehicleSelect: (id: string) => void
}

export const VehicleListOverlay = ({
  selectedVehicleId,
  vehicles,
  handleVehicleSelect,
}: VehicleListOverlayProps) => {
  return (
    <div
      css={theme => ({
        userSelect: 'none',
        overflowY: 'auto',
        background: `${theme.semantic.ColorSurfaceDefault}`,
        borderRadius: theme.radius.RadiusMedium,
        boxShadow: theme.shadows[2],
      })}
      data-testid={List}
    >
      {vehicles.map(vehicle => (
        <VehicleListOverlayRow
          key={vehicle.id}
          vehicle={vehicle}
          isSelected={selectedVehicleId === vehicle.id}
          onClick={() => {
            trackClickEvent(`fleetmap_list__click_vehicle`)
            handleVehicleSelect(vehicle.id)
          }}
        />
      ))}
    </div>
  )
}
